import React, { memo } from 'react';
import PropTypes from 'prop-types';
import format from 'date-fns/format';
import _isEqual from 'lodash/isEqual';
import { useDispatch } from 'react-redux';

import ExportModal from 'components/ExportModal';
import StatusBadge from 'components/StatusBadge';

import { payoutDetails as TEXT } from 'locales/en/payout';
import { DAY_MONTH_YEAR } from 'utils/dateFormat';
import { exportPayouts } from 'redux/slices/payout';

const Summary = ({ payout }) => {
  const dispatch = useDispatch();
  const { amountToDisplay, status } = payout;

  return (
    <div className="card mb-8 p-0">
      <div className="p-6 lg:p-12">
        <p className="text-javelin-gray-light text-xs mb-3">{TEXT.net}</p>
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            <span className="font-bold text-3xl">{amountToDisplay}</span>
            <StatusBadge status={status} />
          </div>
          <ExportModal
            onConfirm={() =>
              dispatch(
                exportPayouts({ id: payout.id, created_at: payout.created_at })
              )
            }
            title={TEXT.export}
            buttonClass="btn btn-secondary w-44 h-11 px-0 flex-shrink-0"
            icon={null}
          />
        </div>
        <p className="text-javelin-gray-light text-xs mt-3">
          {TEXT.expectedArrival}{' '}
          <b>
            {format(new Date(payout.estimated_arrival_date), DAY_MONTH_YEAR)}
          </b>
        </p>
      </div>
    </div>
  );
};

Summary.propTypes = {
  payout: PropTypes.shape({}),
};
Summary.defaultProps = {
  payout: {},
};

const areEqual = (prevProps, nextProps) => {
  return _isEqual(prevProps.payout, nextProps.payout);
};

export default memo(Summary, areEqual);
